import { EMPTY_LIST } from '../../../constants/common'
import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'
import { EXCLUDE_FILTERS } from '../../Filter'

export function getEntityTabBuildingGroupsExcludeFilters(scopeFilterKey) {
  return [
    ...EXCLUDE_FILTERS,
    ...(scopeFilterKey ? [scopeFilterKey] : EMPTY_LIST),
    FILTER_NAME_SUB_MENU,
  ]
}
